import { client } from '@atlassian/rovo-content-bridge-api';

export const JSM_CREATE_SURVEY_CLIENT_ID = client('jsm-create-survey');
